class RecaptchaService {
  $timeout: any
  $window: any
  $rootScope: ng.IRootScopeService
  _grecaptcha: any = null
  siteKey: string | null
  skip: boolean
  initialized = false

  constructor($window: any, $timeout: any, $rootScope: ng.IRootScopeService, config: any) {
    this.$window = $window
    this.$timeout = $timeout
    this.$rootScope = $rootScope
    this.siteKey = config?.data?.recaptcha?.siteKey || null

    this.skip = !this.siteKey || !!$window.__skipRecaptcha__

    if (!this.skip) {
      this.waitForGrecaptcha()
    }
  }

  private waitForGrecaptcha() {
    if (this.skip) return

    const g = this.$window.grecaptcha

    if (g?.enterprise?.execute) {
      this._grecaptcha = g.enterprise
      this.initialized = true
      console.log(" reCAPTCHA Enterprise initialized")
      return
    }

    this.$timeout(() => this.waitForGrecaptcha(), 100)
  }

  execute(action: string, elementId?: string): Promise<string> {
  console.log(" RecaptchaService.execute called", { action, elementId })

  return new Promise((resolve, reject) => {

    if (this.skip) {
      console.warn("reCAPTCHA skipped - siteKey missing OR __skipRecaptcha__ true")

      console.log("Broadcasting recaptchaValidated (skip mode)")
      this.$rootScope.$broadcast("recaptchaValidated", true)
      if (!this.$rootScope.$$phase) {
        this.$rootScope.$applyAsync()
      }

      resolve("test-bypass")
      return
    }

    if (!this._grecaptcha || !this.siteKey) {
      console.error(" reCAPTCHA not ready", {
        grecaptcha: this._grecaptcha,
        siteKey: this.siteKey
      })
      reject("reCAPTCHA not ready")
      return
    }

    this._grecaptcha.ready(() => {
      this._grecaptcha
        .execute(this.siteKey, { action })
        .then((token: string) => {

          console.log("Broadcasting recaptchaValidated to Angular scopes")
          this.$rootScope.$broadcast("recaptchaValidated", true)

          if (!this.$rootScope.$$phase) {
            this.$rootScope.$applyAsync()
          }


          resolve(token)
        })
        .catch((e: any) => {
          console.error("execute() error", e)
          reject(e)
        })
    })
  })
}
//No need for render or reset recaptcha in enterprise mode
}

RecaptchaService.$inject = ['$window', '$timeout', "$rootScope", 'configService']

angular.module('summonApp.services')
   .service('recaptchaService', RecaptchaService)
